<ng-container *ngTemplateOutlet="(inItemEditorModal && !isMobile) ? itemEditorModalHeader : undefined"></ng-container>
<div [ngClass]="{'padded-top-20 padded-bottom-20 choice-groups-container': inItemEditorModal && !isMobile}">
  <ng-container *ngIf="ingredientChoicesType === ingredientChoicesTypeEnum.Pills">
    <div class='padded-right-20-md padded-right-20-sm padded-right-sm-down padded-left-20' [ngClass]="{'padded-right-20': inItemEditorModal && !isMobile}">
      <div class="btn-group choice-groups d-block">
        <button *ngFor="let choiceGroup of filteredGroups; trackBy: trackByChoiceGroupFn;"
           class="btn choice-group-btn primary-bg-color shadowed fw-300 font-secondary"
           [ngClass]="{'selection-bg-color selection-inverse-text-color': selectedChoiceGroup?.name === choiceGroup.name}"
           [ngModel]="selectedChoiceGroup?.name"
           [attr.aria-pressed]="choiceGroup.name === selectedChoiceGroup?.name"
           (click)='onChoiceGroupChange(choiceGroup, $event)'
           [value]="choiceGroup.name"
           ngDefaultControl>
          <span>{{choiceGroup.name}}</span>
        </button>
      </div>
    </div>
    <fts-pills-choices [choices]="(choices  | choiceGroupFilter:selectedChoiceGroup?.choices)"
                       [selectedChoice]="selectedChoice"
                       [item]="item"
                       [hideSinglePill]="true"
                       [ignoreIngredientGroups]="selectedChoiceGroup?.choices?.length > 1"
                       [smallPills]="true"
                       [caloriesDisclaimer]="caloriesDisclaimer"
                       [inModal]='inModal'
                       [inItemEditorModal]="inItemEditorModal"
                       [hasGraphicalBuilder]="hasGraphicalBuilder"
                       [ingredientChoicesType]="ingredientChoicesType"
                       [itemHasGroupChoices]="true"
                       (choiceChange)="onChoiceChange($event)"
                       (halfSelectionChange)='onHalfSelectionChange($event)'
                       (qualifierSelectionChange)='onQualifierSelectionChange($event)'
                       (ingredientSelectionsChange)='onIngredientSelectionsChange($event)'
                       (stageActionChange)="onStageActionChange($event)"
                       [isHalfAndHalf]="isHalfAndHalf"></fts-pills-choices>
  </ng-container>
  
  <ng-container *ngIf="ingredientChoicesType === ingredientChoicesTypeEnum.List">
    <div class='padded-right-20-md padded-right-20-sm padded-right-sm-down padded-left-20' [ngClass]="{'overlay': isMobile, 'padded-right-20': inItemEditorModal && !isMobile}">
      <ng-container *ngFor="let choiceGroup of filteredListGroups; trackBy: trackByChoiceGroupFn;">
        <div class="ingredient-choices">
          <button class="btn btn-link btn-undecorated btn-block list-btn-choice text-left fw-300 ingredient-choice font-secondary"
                  (click)='onChoiceGroupToggle(choiceGroup, $event)' [attr.aria-expanded]="choiceGroup.isExpanded">
            <div class="choice-wrapper">
              <fa-icon class="expander" [ngClass]="{'fa-rotate-90': choiceGroup.isExpanded}" [fixedWidth]="true" [icon]="faAngleRight"></fa-icon>
              <div class="choice-name-and-warning">
                <div style="display: flex; flex-direction: column;">
                  <span>{{choiceGroup.name}}</span>
                  <span class="whole-application-label" *ngIf="isHalfAndHalf && isMobile && !choiceGroup.ingredientChoices[0].hasHalves && choiceGroup.choices.length == 1">
                    {{'component.item_editor.choice.will_be_applied_to_both_halves' | translate}}
                  </span>
                </div>
                <div class="message-wrapper">
                  <span class="badge bg-warning text-uppercase choice-attention-label primary-text-color max-height-width-fit" 
                  *ngIf='(item | invalidChoiceGroup : choiceGroup) && !choiceGroup.isExpanded' data-flash>
                    {{'component.choice_groups.attention' | translate}}
                  </span>
                  <span 
                    class="text-uppercase halfs-whole-warning d-flex will-apply-both-havles-message" 
                    *ngIf="isHalfAndHalf && !choiceGroup.ingredientChoices[0].hasHalves && !isMobile && choiceGroup.choices.length == 1">
                      {{'component.item_editor.item_choices.pills_choices.will_be_applied_to_both_halves' | translate}}
                  </span>
                </div>
              </div>
            </div>
          </button>
        </div>
        
        <div class='choice-details' [ngClass]="{'collapsed': !choiceGroup.isExpanded}"
            [@expanded]="choiceGroup.isExpanded">
          <ng-container *ngIf="choiceGroup.isExpanded">
            <fts-pills-choices [choices]="choiceGroup.ingredientChoices"
                              [selectedChoice]="choiceGroup.selectedChoice"
                              [item]="item"
                              [hideSinglePill]="true"
                              [ignoreIngredientGroups]="choiceGroup?.choices?.length > 1"
                              [smallPills]="true"
                              [caloriesDisclaimer]="caloriesDisclaimer"
                              [inModal]='inModal'
                              [hasGraphicalBuilder]="hasGraphicalBuilder"
                              [ingredientChoicesType]="ingredientChoicesType"
                              [inItemEditorModal]="inItemEditorModal"
                              [itemHasGroupChoices]="true"
                              (choiceChange)="onChoiceChange($event, choiceGroup.name)"
                              (halfSelectionChange)='onHalfSelectionChange($event)'
                              (qualifierSelectionChange)='onQualifierSelectionChange($event)'
                              (ingredientSelectionsChange)='onIngredientSelectionsChange($event)'
                              (stageActionChange)="onStageActionChange($event)"
                              [isHalfAndHalf]="isHalfAndHalf"></fts-pills-choices>
          </ng-container>
        </div>
        <hr class='no-margin' aria-hidden="true">
      </ng-container>
    </div>
  </ng-container>
  
  <ng-container *ngIf="ingredientChoicesType === ingredientChoicesTypeEnum.Steps">
    <div class='steps-wrapper'
      #stepsWrapper
      *ngIf="!isMobile && !inItemEditorModal"
      [ngStyle]="{'width': (inModal || inItemEditorModal) ? '100%' : 'calc(100vw - ' + leftStepsWrapperPosition + ')'}">
      <div class='steps-ingredient-choices-wrapper gray-background-color'>
        <div class='steps-ingredient-choices primary-border-color fw-600' #scrollLinksWrapper>
          <div class="primary-text-color gray-border-color"></div>
          <div *ngIf='(item | invalidChoiceGroup : filteredGroups[0])'
              class='selection-bg-color selection-inverse-text-color selection-border-color active'>
          </div>
          <div *ngFor="let choiceGroup of filteredGroups; trackBy: trackByChoiceGroupFn;"
                #scrollLink
                [tabindex]="(choiceGroup | canMoveToStepGroup : item : selectedChoiceGroup : choiceGroups) ? 0 : -1"
                [attr.aria-disabled]="!(choiceGroup | canMoveToStepGroup : item : selectedChoiceGroup : choiceGroups)"
                role="button"
                (keypress.enter)="onChoiceGroupChange(choiceGroup, $event)"
                (keypress.space)="onChoiceGroupChange(choiceGroup, $event)"
                [attr.aria-pressed]="((choiceGroup | groupIndex : choiceGroups) === (selectedChoiceGroup | groupIndex : choiceGroups)) &&
                  (selectedChoice?.name !== choices[0]?.name || ((selectedChoiceGroup | groupIndex : choiceGroups) !== 0 || ((item | orderedChoice : choices[0]?.name) | valid)))"
                (click)='onChoiceGroupChange(choiceGroup, $event)'
                class="primary-text-color gray-border-color cursor-pointer"
                [ngClass]="{'selection-bg-color selection-inverse-text-color selection-border-color active':
                  ((choiceGroup | groupIndex : choiceGroups) === (selectedChoiceGroup | groupIndex : choiceGroups)) &&
                  (selectedChoice?.name !== choices[0]?.name || ((selectedChoiceGroup | groupIndex : choiceGroups) !== 0 || ((item | orderedChoice : choices[0]?.name) | valid))),
                'default-cursor': !(choiceGroup | canMoveToStepGroup : item : selectedChoiceGroup : choiceGroups) && !(item | valid)}">
              <span>{{choiceGroup?.name}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="choice-groups-header" *ngIf="isMobile">
      <div class="selected-choice-group fw-600 text-uppercase font-secondary">{{selectedChoiceGroup?.name}}</div>
      <div class="steps-controls">
        <button
          class="btn btn-sm btn-link btn-undecorated step-control padding-x"
          [ngClass]="{'selection-text-color selection-inverse-bg-color': !isFirstChoiceGroup}"
          (click)="moveToPreviousChoiceGroup()">
          <fa-icon [icon]="faAngleLeft" size="lg"></fa-icon>
          {{'component.choice_groups.back' | translate}}
        </button>
        <div class="step-control">
          {{'component.choice_groups.steps' | translate: {current: (selectedChoiceGroup | groupIndex : choiceGroups) + 1, maxSteps: filteredGroups.length} }}
        </div>
        <button
          class="btn btn-sm btn-link btn-undecorated step-control padding-x"
          [ngClass]="{'selection-text-color selection-inverse-bg-color': !isLastChoiceGroup && !(item | invalidChoiceGroup : selectedChoiceGroup)}"
          (click)="moveToNextChoiceGroup()">
          {{'component.choice_groups.next' | translate}}
          <fa-icon [icon]="faAngleRightLight" size="lg"></fa-icon>
        </button>
      </div>
    </div>
    <div class="padded-right-20 padded-left-20" [ngClass]="{'overlay padded-top-20': isMobile}" id="choiceGroup">
      <fts-pills-choices [choices]="(choices  | choiceGroupFilter:selectedChoiceGroup?.choices)"
                        [selectedChoice]="selectedChoice"
                        [item]="item"
                        [hideSinglePill]="true"
                        [ignoreIngredientGroups]="selectedChoiceGroup?.choices?.length > 1"
                        [smallPills]="true"
                        [capitalize]='true'
                        [caloriesDisclaimer]="caloriesDisclaimer"
                        [inModal]='inModal'
                        [hasGraphicalBuilder]="hasGraphicalBuilder"
                        [ingredientChoicesType]="ingredientChoicesType"
                        [hasChoiceGroups]="!!choiceGroups?.length"
                        [inItemEditorModal]="inItemEditorModal"
                        (choiceChange)="onChoiceChange($event)"
                        (halfSelectionChange)='onHalfSelectionChange($event)'
                        (qualifierSelectionChange)='onQualifierSelectionChange($event)'
                        (ingredientSelectionsChange)='onIngredientSelectionsChange($event)'
                        (stageActionChange)="onStageActionChange($event)"
                        [isHalfAndHalf]="isHalfAndHalf"></fts-pills-choices>
    </div>
  </ng-container>
  
  <ng-content></ng-content>
  
  <fts-step-controls *ngIf="!inModal && !(isMobile && isHalfAndHalf ) && (!inItemEditorModal || isMobile) && ((isMobile && ingredientChoicesType !== ingredientChoicesTypeEnum.Steps) || ingredientChoicesType === ingredientChoicesTypeEnum.Steps)"
                      [hasBackBtn]="shouldShowBackBtn"
                      [hasForwardBtn]="shouldShowForwardBtn"
                      [hasSubmitBtn]="shouldShowSubmitBtn"
                      [forwardBtnItemLabel]="nextChoiceGroup?.name"
                      [submitBtnLabel]="submitBtnLabel"
                      [forwardBtnDisabled]="(item | invalidChoiceGroup : selectedChoiceGroup)"
                      [isItemValid]="(item | valid)"
                      [isHalfAndHalf]="isHalfAndHalf"
                      [submitLoadingSubscription]="submitLoadingSubscription"
                      (backBtnClick)="moveToPreviousChoiceGroup()"
                      (forwardBtnClick)="moveToNextChoiceGroup()"
                      (submitBtnClick)="onSubmitBtnClick()">
    <fts-price *ngIf="!inItemEditorModal" class="custom-left-content" [price]='price'></fts-price>
  </fts-step-controls>
</div>

<fts-item-editor-modal-footer 
  *ngIf="inItemEditorModal && !isMobile"
  [hasBackBtn]="shouldShowBackBtn"
  [hasForwardBtn]="shouldShowForwardBtn"
  [hasSubmitBtn]="shouldShowSubmitBtn"
  [forwardBtnItemLabel]="nextChoiceGroup?.name"
  [submitBtnLabel]="submitBtnLabel"
  [forwardBtnDisabled]="(item | invalidChoiceGroup : selectedChoiceGroup)"
  [isItemValid]="(item | valid)"
  [submitLoadingSubscription]="submitLoadingSubscription"
  [selectedChoiceGroup]="selectedChoiceGroup"
  [ingredientChoicesType]="ingredientChoicesType"
  [hasChoiceGroups]="!!orderableItem.choiceGroups?.length"
  [selectedChoice]="selectedChoice"
  (backBtnClick)="moveToPreviousChoiceGroup()"
  (forwardBtnClick)="moveToNextChoiceGroup()"
  (submitBtnClick)="onSubmitBtnClick()"
  (cancelBtnClick)="onCancelBtnClick()"
  [isHalfAndHalf]="isHalfAndHalf"
></fts-item-editor-modal-footer>

<ng-template #itemEditorModalHeader>
  <fts-item-editor-modal-header
      [isMobile]="isMobile"
      [inItemEditorModal]="inItemEditorModal"
      [ingredientChoicesType]="ingredientChoicesType"
      [orderableItem]="orderableItem"
      [item]="item"
      [choices]="choices"
      [filteredGroups]="filteredGroups"
      [trackByChoiceGroupFn]="trackByChoiceGroupFn"
      [choiceGroups]="choiceGroups"
      [selectedChoiceGroup]="selectedChoiceGroup"
      [selectedChoice]="selectedChoice"
      (choiceGroupChange)="onChangeChoiceGroup($event)"
      (loadComponent)="onLoadItemEditorModalHeaderComponent($event)"
      (cancelBtnClick)="onCancelBtnClick()"
    ></fts-item-editor-modal-header>
</ng-template>

